<template>
  <div>
    <HeroBanner
      v-if="banner"
      :align
      :badge
      :class="visibilityClasses.heroBannerClasses"
      :gradient-enabled="banner.gradientEnabled"
      :headingType
      :hiddenDevices="banner.hiddenDevices"
      :image="banner.image"
      :relatedLinks="banner.relatedLinks"
      :subtitle
      :textColor="banner.textColor"
      :title
      :titleSize="banner.titleSize"
    />

    <slot name="breadcrumb" />

    <RevContainer
      class="mb-56"
      :class="visibilityClasses.heroSectionClasses"
      data-test="hero-section"
    >
      <div :class="{ 'text-center': align === 'center' }">
        <Heading
          :badge
          class="mx-0"
          data-test="heading"
          :heading-type="banner ? 'p' : headingType"
          size="large"
          :title
        />

        <RichText
          v-if="subtitle"
          class="heading-3 mt-8 inline-flex md:max-w-[736px]"
          :rich-text="subtitle"
          style-variant="none"
        />
      </div>
    </RevContainer>
  </div>
</template>

<script setup lang="ts">
import { type VNode, computed } from 'vue'

import type { Banner } from '@backmarket/http-api/src/api-specs-content/models/banner'
import type { BasePageContentAPI } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { RichText as RichTextType } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import RichText from '@backmarket/nuxt-layer-cms/RichText.vue'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevContainer } from '@ds/components/Container'

import Heading from '../Heading/Heading.vue'

import HeroBanner from './HeroBanner.vue'
import { getVisibilityClasses } from './devices'

defineSlots<{
  breadcrumb?(): VNode
}>()

const {
  banner,
  badge,
  title,
  align = 'left',
  subtitle = undefined,
  headingType = 'h1',
} = defineProps<{
  banner?: Maybe<Banner>
  badge?: Maybe<string>
  title?: Maybe<string>
  align?: BasePageContentAPI['align']
  subtitle?: Maybe<RichTextType>
  headingType?: 'h1' | 'p'
}>()

const visibilityClasses = computed(() => {
  if (!banner) {
    return {
      heroBannerClasses: 'hidden',
      heroSectionClasses: '',
    }
  }

  const { visibilityClasses: heroBannerClasses, opposite: heroSectionClasses } =
    getVisibilityClasses(banner.hiddenDevices)

  return {
    heroBannerClasses,
    heroSectionClasses,
  }
})
</script>
